import styled from 'styled-components';
import { getTextType, getColor, mq, getGridSpans, getSpace } from '../../../stylesheets/tools';

const dotsHuman = '/static/dots/did-you-know-dots-human.svg';
const dotsTechnology = '/static/dots/did-you-know-dots-technology.svg';
const dotsNature = '/static/dots/did-you-know-dots-nature.svg';

const StyledDidYouKnowDivider = styled.div`
  position: relative;
  margin-bottom: 160px;

  .didYouKnowDivider__dots {
    position: absolute;
    bottom: -350px;
    width: 100%;
    height: 436px;
    background-size: 592px 436px;
    background-repeat: repeat;
    transform: scaleY(-1);

    background-image: ${props => {
      switch (props.color) {
        case 'blue':
          return `url(${dotsHuman})`;
        case 'grey':
          return `url(${dotsTechnology})`;
        case 'green':
          return `url(${dotsNature})`;
        default:
          return false;
      }
    }};
  }

  .didYouKnowDivider__wrapper {
    background-color: ${props => {
      switch (props.color) {
        case 'blue':
          return getColor('mfBlue');
        case 'grey':
          return getColor('mfGrey');
        case 'green':
          return getColor('mfGreen');
        default:
          return false;
      }
    }};
  }

  .didYouKnowDivider__icon {
    flex-shrink: 0;
    margin-top: -24px;
    &--mobile {
      display: block;
      align-self: flex-end;
      margin-bottom: 11px;

      ${mq('m')} {
        display: none;
      }
    }

    &--desktop {
      display: none;

      ${mq('m')} {
        display: block;
        margin-right: ${getSpace('xs')};
      }
    }
  }

  .didYouKnowDivider__content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    ${getGridSpans('width', { s: 11, m: 7 })}
    ${getGridSpans('margin-left', { s: [1, 'spread'], m: 0 })};

    ${mq('m')} {
      flex-direction: row;
      padding-top: ${getSpace('xxl')};
    }

    ${props =>
      props.alignment === 'right'
        ? getGridSpans('margin-left', { m: 5 })
        : `${mq('m')} {margin-left: ${getSpace('l')}}`};
  }

  .didYouKnowDivider__copy,
  .didYouKnowDivider__hint {
    margin: 1.25rem 0px;
  }

  .didYouKnowDivider__copy *,
  .didYouKnowDivider__hint * {
    margin: 0px;
  }

  .didYouKnowDivider__copy,
  .didYouKnowDivider__copy p {
    ${getTextType('copy', 'international')}
  }
  .didYouKnowDivider__hint,
  .didYouKnowDivider__hint p {
    ${getTextType('copySmall', 'international')}
  }
`;

export default StyledDidYouKnowDivider;
